import { useEffect } from 'react';
import { expVal } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';
import { useQueryParam, useRouter } from '@atlassian/react-resource-router';
import { useProjectBuilder } from '../../services/use-project-builder/use-project-builder.tsx';

const CROSS_FLOW_SOURCE_QUERY_PARAM = 'source';
const CROSS_FLOW_SOURCE_VALUE = 'cross-flow';

const ProjectBuilderCrossFlowSourceTrigger = (): null => {
	const [sourceQueryParam, setSourceQueryParam] = useQueryParam(CROSS_FLOW_SOURCE_QUERY_PARAM);
	const [{ route }] = useRouter();
	const [, actions] = useProjectBuilder();

	useEffect(() => {
		const triggerRoutes: string[] = [
			'servicedesk-queues-landing',
			'servicedesk-getting-started-page',
			...(fg('csm_appification_standalone_navigation') ? ['csm-queues-landing'] : []),
		];
		if (sourceQueryParam === CROSS_FLOW_SOURCE_VALUE && triggerRoutes.includes(route.name)) {
			if (expVal('sequoia_jsmgrowth-219_bring_forwaed_request_types', 'isEnabled', false)) {
				actions.showProjectBuilder();
			}

			setSourceQueryParam(undefined);
		}
	}, [actions, sourceQueryParam, route.name, setSourceQueryParam]);

	return null;
};

export default ProjectBuilderCrossFlowSourceTrigger;
